export default __webpack_public_path__ + "static/media/star-3-index.f9bfa0d2.svg";